import { useCallback, useState } from 'react'

import type { FanResponseDto } from '@api'
import sortBy from 'lodash/sortBy'
import take from 'lodash/take'

import { Button } from '@/components/ui/button'
import { DIALOG_TYPE } from '@/dialogs/constants.ts'
import { openDialog } from '@/models/dialogs.ts'

import ChevronDownIcon from '../../../icons/chevron-down.svg'
import EditIcon from '../../../icons/edit.svg'
import ListIcon from '../../../icons/list.svg'
import { IconButton } from '../../components/icon-button'
import { unescapeHtmlText } from './utils'

interface Props {
  fan: FanResponseDto
}

export const FanLists = ({ fan }: Props) => {
  const [isListExpanded, setIsListExpanded] = useState(false)
  const sortedLists = sortBy(
    fan.listsStates?.filter((list) => list.hasUser),
    (list) => list.name.toLowerCase(),
  )
  const handleOpenManageListsDialog = useCallback(() => {
    openDialog({
      type: DIALOG_TYPE.SAVE_TO_LIST,
    })
  }, [])

  return (
    <div className="space-y-4 rounded-md bg-card p-3">
      <div className="flex items-center justify-between gap-2 rounded-md bg-secondary-50 p-2 text-title dark:bg-secondary-600">
        <ListIcon />
        <p className="flex-1 text-sm font-bold">Lists</p>
        <IconButton
          tooltip="Edit"
          onClick={handleOpenManageListsDialog}
          icon={EditIcon}
          className="text-primary-500"
        />
      </div>
      {sortedLists.length > 0 && (
        <div>
          {(isListExpanded ? sortedLists : take(sortedLists, 5)).map(
            ({ id, name }) => (
              <div
                className="flex gap-2 px-1 py-1 text-sm"
                key={id}
              >
                <span>&#x2022;</span>
                {unescapeHtmlText(name)}
              </div>
            ),
          )}
          {sortedLists && sortedLists.length > 5 && (
            <Button
              variant="outline"
              className="mt-2 flex h-max w-full items-center gap-2 border-primary-500 py-1 text-primary-500 hover:border-primary-500 hover:bg-primary-50 hover:text-primary-500"
              onClick={() => setIsListExpanded((old) => !old)}
            >
              <div
                style={{
                  // eslint-disable-next-line no-inline-styles/no-inline-styles
                  transformOrigin: 'center',
                  transform: isListExpanded ? 'rotate(180deg)' : undefined,
                }}
              >
                <ChevronDownIcon />
              </div>
              {/* eslint-disable-next-line no-inline-styles/no-inline-styles */}
              <span style={{ marginLeft: 4 }}>
                Show {isListExpanded ? 'less' : 'more'}
              </span>
            </Button>
          )}
        </div>
      )}
    </div>
  )
}
